export function OutlineMaintenanceIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2774 12.9972C17.5574 14.7172 15.0375 15.1412 12.9127 14.2691L6.18188 21L2.98267 17.8008L9.71354 11.0699C8.84146 8.94996 9.26545 6.4301 10.9855 4.70522C12.7056 2.98035 15.3411 2.5419 17.4851 3.49107L13.25 7.72617L16.2613 10.7375L20.4964 6.50237C21.4408 8.64642 21.0312 11.2482 19.2823 13.002L19.2774 12.9972Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
